import React from "react";
import {
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Container,
  FormText,
  Progress
} from "reactstrap";
import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";
import { commonService } from "../../_services";

//Page Utilities
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
// import PageEmptyContent from "../utils/page.empty-content";

//Icons
import EditIcon from "react-icons/lib/md/edit";
import BackIcon from "react-icons/lib/md/arrow-back";
import SaveIcon from "react-icons/lib/md/save";
// import FlightIcon from 'react-icons/lib/md/flight-takeoff';
import { appHelpers, store } from "../../_helpers";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class FlagMetricsViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IntlMaxTscDollar: "",
      IntlMinTscDollar: "",
      IntlMaxTscNaira: "",
      IntlMinTscNaira: "",
      DomMaxTscDollar: "",
      DomMinTscDollar: "",
      DomMaxTscNaira: "",
      DomMinTscNaira: "",

      flagMetrics: {},

      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },

      //MakerChecker
      createFlagMetricsEntityTypeId: null,
      isEditMode: false
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { entities } = reduxState;
    const { dispatch } = this.props;
    // console.log(flagMetrics)
    // if (flagMetrics) {
    //     this.setState({ flagMetrics: flagMetrics });
    // } else {
    //     console.log("fetch flag metrics")
    this.fetchFlagMetrics();
    // }

    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
  }

  componentWillReceiveProps = function(nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }
    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  setEntityTypes = entities => {
    let createFlagMetricsEntityTypeId;

    entities.forEach(entity => {
      if (entity.EntityType === appConstants.APP_ENTITIES.CREATE_FLAG_METRICS) {
        createFlagMetricsEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ createFlagMetricsEntityTypeId });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  fetchFlagMetrics = () => {
    const { dispatch } = this.props;
    dispatch(apiActions.startFullPageRequest());
    dispatch(commonActions.getFlagMetrics())
      .then(() => {
        dispatch(apiActions.endRequest());
        let { flagMetrics } = this.props;
        this.setState({
          flagMetrics: flagMetrics,
          IntlMaxTscDollar: flagMetrics.IntlMaxTscDollar,
          IntlMinTscDollar: flagMetrics.IntlMinTscDollar,
          IntlMaxTscNaira: flagMetrics.IntlMaxTscNaira,
          IntlMinTscNaira: flagMetrics.IntlMinTscNaira,
          DomMaxTscDollar: flagMetrics.DomMaxTscDollar,
          DomMinTscDollar: flagMetrics.DomMinTscDollar,
          DomMaxTscNaira: flagMetrics.DomMaxTscNaira,
          DomMinTscNaira: flagMetrics.DomMinTscNaira
        });
      })
      .catch(error => {
        dispatch(apiActions.endRequest());
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      });
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.IntlMaxTscDollar === "") {
      _errs_["IntlMaxTscDollar"] = "Please enter a value";
      formValid = false;
    }
    if (this.state.IntlMinTscDollar === "") {
      _errs_["IntlMinTscDollar"] = "Please enter a value";
      formValid = false;
    }
    if (this.state.IntlMaxTscNaira === "") {
      _errs_["IntlMaxTscNaira"] = "Please enter a value";
      formValid = false;
    }
    if (this.state.IntlMinTscNaira === "") {
      _errs_["IntlMinTscNaira"] = "Please enter a value";
      formValid = false;
    }
    if (this.state.DomMaxTscDollar === "") {
      _errs_["DomMaxTscDollar"] = "Please enter a value";
      formValid = false;
    }
    if (this.state.DomMinTscDollar === "") {
      _errs_["DomMinTscDollar"] = "Please enter a value";
      formValid = false;
    }
    if (this.state.DomMaxTscNaira === "") {
      _errs_["DomMaxTscNaira"] = "Please enter a value";
      formValid = false;
    }
    if (this.state.DomMinTscNaira === "") {
      _errs_["DomMinTscNaira"] = "Please enter a value";
      formValid = false;
    }

    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = notification => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      FlightId: false,
      AirlineId: "",
      FlightNumber: "",
      DestinationCountryId: "",
      DepartureAirportId: "",
      DestinationAirportId: "",
      DepartureCountryId: "",
      Active: false,
      IsLocal: false,
      FlightDays: []
    });
    this.resetError();
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  processSubmit = () => {
    let {
      //   createFlagMetricsEntityTypeId,
      IntlMaxTscDollar,
      IntlMinTscDollar,
      IntlMaxTscNaira,
      IntlMinTscNaira,
      DomMaxTscDollar,
      DomMaxTscNaira,
      DomMinTscDollar,
      DomMinTscNaira
    } = this.state;
    // const { authentication } = store.getState();
    const userRole = appHelpers.getActiveUser().AviRole;

    let payload = {
      IntlMaxTscDollar: IntlMaxTscDollar,
      IntlMinTscDollar: IntlMinTscDollar,
      IntlMaxTscNaira: IntlMaxTscNaira,
      IntlMinTscNaira: IntlMinTscNaira,
      DomMaxTscDollar: DomMaxTscDollar,
      DomMinTscDollar: DomMinTscDollar,
      DomMaxTscNaira: DomMaxTscNaira,
      DomMinTscNaira: DomMinTscNaira
    };

    if (userRole === appConstants.ROLES.VGG_ADMIN) {
      this.createMakerChecker(payload);
    } else {
      this.createFlagMetrics(payload);
    }
  };

  createFlagMetrics = (payload) => {
    const { dispatch } = this.props;

    dispatch(apiActions.startRequest());
    commonService.createFlagMetrics(payload).then(res => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
            this.toggleView();
            let msg = "Flag metrics saved successfully";
            this.notify(msg, appConstants.NOTIFY_SUCCESS);
            dispatch(apiActions.endRequest());
            this.fetchFlagMetrics();
        } else if (res.status === appConstants.ERROR_RESPONSE) {
            dispatch(alertActions.error(res.response));
            dispatch(apiActions.endRequest());
        }
      });
    };
  

  createMakerChecker = payload => {
    const {
      IntlMaxTscDollar,
      IntlMinTscDollar,
      IntlMinTscNaira,
      IntlMaxTscNaira,
      DomMaxTscDollar,
      DomMaxTscNaira,
      DomMinTscDollar,
      DomMinTscNaira,
      createFlagMetricsEntityTypeId
    } = this.state;
    const { authentication } = store.getState();
    const { dispatch } = this.props;

    /* Maker Checker */
    let payloadTemplate = {
      "Avicollect Intl. Min. TSC Amount ($)": IntlMinTscDollar,
      "Avicollect Intl. Max. TSC Amount ($)": IntlMaxTscDollar,
      "Avicollect Intl. Min. TSC Amount (N)": IntlMinTscNaira,
      "Avicollect Intl. Max. TSC Amount (N)": IntlMaxTscNaira,
      "Avicollect Dom. Min. TSC Amount ($)": DomMinTscDollar,
      "Avicollect Dom. Max. TSC Amount ($)": DomMaxTscDollar,
      "Avicollect Dom. Min. TSC Amount (N)": DomMinTscNaira,
      "Avicollect Dom. Max. TSC Amount (N)": DomMaxTscNaira
    };

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${appConstants.PAS_URL}/api/AirlineMetrics/SaveFlagMetric`,
      EntityTypeId: createFlagMetricsEntityTypeId,
      CreatedBy: authentication.user.userName
    };

    dispatch(apiActions.startRequest());
    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggleView();
        let msg = "Flag metrics update sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
        this.fetchFlagMetrics();
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  toggleView = () => {
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  backToFlagMetrics = () => {
    this.toggleView();
    this.fetchFlagMetrics();
  };

  render() {
    let { requesting, pageRequesting } = this.props;
    let { contentError, componentErrorMessages, isEditMode } = this.state;

    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}

            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <div className="row">
                  <h6 className="mb-4 col-md-8 text-uppercase pull-left">
                    Flag Metrics
                  </h6>
                  <div className="mb-4 col-md-4 text-right">
                    {!isEditMode && (
                      <Button
                        className="btn-avi-primary"
                        onClick={this.toggleView}
                      >
                        <EditIcon color="#ffffff" size="20" />
                        &nbsp;Edit
                      </Button>
                    )}{" "}
                    {isEditMode && (
                      <Button
                        color="secondary"
                        onClick={this.backToFlagMetrics}
                      >
                        <BackIcon size="20" />
                        &nbsp;Back
                      </Button>
                    )}{" "}
                    {isEditMode && (
                      <Button
                        className="btn-avi-primary"
                        onClick={this.handleSubmit}
                      >
                        <SaveIcon color="#ffffff" size="20" />
                        &nbsp;Save Changes
                      </Button>
                    )}
                  </div>
                </div>

                {!pageRequesting && (
                  <div>
                    <Container>
                      <Row>
                        <Col md="6">
                          <h3>Avicollect International</h3>

                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages
                                .IntlMinTscDollar
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Minimum TSC Amount ($)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.IntlMinTscDollar}
                              onChange={event =>
                                this.handleChange(event, "IntlMinTscDollar")
                              }
                            />
                            {componentErrorMessages.IntlMinTscDollar && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.IntlMinTscDollar}
                              </FormText>
                            )}
                          </FormGroup>

                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages
                                .IntlMaxTscDollar
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Maximum TSC Amount ($)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.IntlMaxTscDollar}
                              onChange={event =>
                                this.handleChange(event, "IntlMaxTscDollar")
                              }
                            />
                            {componentErrorMessages.IntlMaxTscDollar && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.IntlMaxTscDollar}
                              </FormText>
                            )}
                          </FormGroup>

                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.IntlMinTscNaira
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Minimum TSC Amount (&#8358;)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.IntlMinTscNaira}
                              onChange={event =>
                                this.handleChange(event, "IntlMinTscNaira")
                              }
                            />
                            {componentErrorMessages.IntlMinTscNaira && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.IntlMinTscNaira}
                              </FormText>
                            )}
                          </FormGroup>

                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.IntlMaxTscNaira
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Maximum TSC Amount (&#8358;)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.IntlMaxTscNaira}
                              onChange={event =>
                                this.handleChange(event, "IntlMaxTscNaira")
                              }
                            />
                            {componentErrorMessages.IntlMaxTscNaira && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.IntlMaxTscNaira}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="6">
                          <h3>Avicollect Domestic</h3>
                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.DomMinTscDollar
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Minimum TSC Amount ($)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.DomMinTscDollar}
                              onChange={event =>
                                this.handleChange(event, "DomMinTscDollar")
                              }
                            />
                            {componentErrorMessages.DomMinTscDollar && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.DomMinTscDollar}
                              </FormText>
                            )}
                          </FormGroup>

                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.DomMaxTscDollar
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Maximum TSC Amount ($)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.DomMaxTscDollar}
                              onChange={event =>
                                this.handleChange(event, "DomMaxTscDollar")
                              }
                            />
                            {componentErrorMessages.DomMaxTscDollar && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.DomMaxTscDollar}
                              </FormText>
                            )}
                          </FormGroup>

                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.DomMinTscNaira
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Minimum TSC Amount (&#8358;)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.DomMinTscNaira}
                              onChange={event =>
                                this.handleChange(event, "DomMinTscNaira")
                              }
                            />
                            {componentErrorMessages.DomMinTscNaira && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.DomMinTscNaira}
                              </FormText>
                            )}
                          </FormGroup>

                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.DomMaxTscNaira
                                ? "has-danger"
                                : "")
                            }
                          >
                            <Label>Maximum TSC Amount (&#8358;)</Label>
                            <Input
                              type="number"
                              disabled={!isEditMode}
                              placeholder=""
                              value={this.state.DomMaxTscNaira}
                              onChange={event =>
                                this.handleChange(event, "DomMaxTscNaira")
                              }
                            />
                            {componentErrorMessages.DomMaxTscNaira && (
                              <FormText color="danger">
                                {" "}
                                {componentErrorMessages.DomMaxTscNaira}
                              </FormText>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                )}
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert, entities, flagMetrics } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    entities,
    flagMetrics
  };
}
export default connect(mapStateToProps)(FlagMetricsViewContent);



// WEBPACK FOOTER //
// ./src/views/flagMetrics/view-content.js